var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M128,10C62.9,10,10,62.9,10,128c0,65.1,52.9,118,118,118c65.1,0,118-52.9,118-118C246,62.9,193.1,10,128,10z M128,233.6c-58.2,0-105.6-47.4-105.6-105.6C22.4,69.8,69.8,22.4,128,22.4c58.2,0,105.6,47.4,105.6,105.6C233.6,186.2,186.2,233.6,128,233.6z M153,63.8c-21.6,0-39.2,17.5-39.2,39.1c0,4.5,0.8,8.8,2.1,12.8l-47.2,46.8c-6.8,6.8-6.8,17.7,0,24.5c6.8,6.8,17.7,6.8,24.5,0l3.3-3.3h9.5c2.2,0,4-1.8,4-4v-9.2h9.2c2.2,0,4-1.8,4-4v-9.3l17.5-17.3c3.9,1.3,8,2,12.3,2c21.6,0,39.2-17.5,39.2-39.1C192.2,81.3,174.6,63.8,153,63.8z M162.4,106.1c-6.7,0-12.2-5.4-12.2-12.1c0-6.7,5.4-12.1,12.2-12.1c6.7,0,12.2,5.4,12.2,12.1C174.6,100.6,169.1,106.1,162.4,106.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/changePassword.0f272fdcb8e6b958626199626a35d526.svg";
export { ForwardRef as ReactComponent };